import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('id');

  useEffect(() => {
    // Load saved language from localStorage
    const savedLanguage = localStorage.getItem('eventime_language');
    console.log('📦 Loading language from localStorage:', savedLanguage);
    if (savedLanguage && ['id', 'en'].includes(savedLanguage)) {
      setCurrentLanguage(savedLanguage);
      console.log('✅ Loaded saved language:', savedLanguage);
    } else {
      console.log('ℹ️ Using default language: id');
    }
  }, []);

  // Log whenever currentLanguage changes
  useEffect(() => {
    console.log('🌐 Current language state updated to:', currentLanguage);
  }, [currentLanguage]);

  const changeLanguage = (lang) => {
    console.log('🔄 changeLanguage called with:', lang);
    if (['id', 'en'].includes(lang)) {
      setCurrentLanguage(lang);
      localStorage.setItem('eventime_language', lang);
      console.log('✅ Language changed to:', lang, 'localStorage:', localStorage.getItem('eventime_language'));
    } else {
      console.error('❌ Invalid language code:', lang);
    }
  };

  const t = (key, params = {}) => {
    const keys = key.split('.');
    let value = translations[currentLanguage];
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation key not found: ${key} for language: ${currentLanguage}`);
        return key;
      }
    }
    
    if (typeof value === 'string') {
      const result = value.replace(/\{(\w+)\}/g, (match, paramKey) => {
        return params[paramKey] || match;
      });
      
      return result;
    }
    
    return key;
  };

  const value = {
    currentLanguage,
    changeLanguage,
    t,
    isIndonesian: currentLanguage === 'id',
    isEnglish: currentLanguage === 'en'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};